import { Project } from 'api/project';
import { RejectNoteType } from 'components/organisms/timesheets/types';
import { ByUser } from './core';
import { EventType } from './event-type';

interface TimesheetEvent {
  start: string;
}

interface UserTimesheetEvent extends TimesheetEvent, ByUser {}

export interface TimesheetDueReminder extends TimesheetEvent {
  eventType: EventType.TimesheetDueReminder;
}

export interface TimesheetOverdueReminder extends TimesheetEvent {
  eventType: EventType.TimesheetOverdueReminder;
}

interface RequestedInfo {
  project?: Project;
}

export interface TimesheetSubmitted extends UserTimesheetEvent {
  eventType: EventType.TimesheetSubmitted;
  info?: RequestedInfo;
}

export interface TimesheetRequested extends UserTimesheetEvent {
  eventType: EventType.TimesheetRequested;
  info?: RequestedInfo;
}

export enum InfoStatus {
  Approved = 'APPROVED',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  PartiallyRejected = 'PARTIALLY_REJECTED',
  Rejected = 'REJECTED',
}

interface ApprovedInfo {
  status: InfoStatus;
  notes?: RejectNoteType[];
  project?: Project;
}

export interface TimesheetApproved extends UserTimesheetEvent {
  eventType: EventType.TimesheetApproved | EventType.TimesheetRejected;
  info?: ApprovedInfo;
}
